module.exports = __webpack_public_path__ + "img/bean.acb08090.png";